export const resizeImageCF = (url, size) => {
  return url.replace("original", `w=${size}`);
};
